export const SCAN_DISPLAY = "SET_SCAN_DISPLAY";